import React, { Component } from 'react';
import EventForm from '../EventForm/Container'
import NewsBox from '../NewsBox'
import Modal from '../Modal'

class Events extends Component {

    componentDidMount(){
	this.props.loadEvents()
	
    }

    constructor(props){
	super(props)
	this.state = {modalVisible: null}
    }
    
    render() {
	const {events, removeEvent, updateEvent, loadEvents} = this.props
	const {modalVisible} = this.state
	const toggleModal = (data) => {

	    let {modalVisible} = this.state
	    modalVisible = data
	    this.setState({modalVisible})
	}

	return (
	    <div>
		{ this.props.authenticated ?
		  <div>
		      <h1>Administracija novic in dogodkov</h1>
		      <button className="btn btn-brown full-width btn-big" onClick={() => toggleModal({})}><i className="fa fa-plus"></i> Dodaj dogodek/novico</button>
		  </div>
		  : ''
		}
		<div>&nbsp;</div>
		<div className="row">
		    
		    {
			events ? 
			events.map((event, index) =>
			    <NewsBox authenticated={this.props.authenticated} key={index} news={event} loadEvents={loadEvents} isMainAction={() => {updateEvent({id: event.id, is_main: !event.is_main})} } deleteAction={() => {removeEvent(event)} } editAction={() => toggleModal(event)} />
			)
			:
			''
		    }
		</div>

		
		
		<Modal toggleModal={() => toggleModal(false)} visible={modalVisible}>
		    <h2>Dodaj dogodek</h2>
		    <EventForm successAction={toggleModal}  initialValues={modalVisible} />
		</Modal>
	    </div>
	);
    }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/Events/index.jsx